/* unplugin-vue-components disabled */import { render } from "./elDialogZlcx.vue?vue&type=template&id=2ba5ef3f"
import script from "./elDialogZlcx.vue?vue&type=script&lang=js"
export * from "./elDialogZlcx.vue?vue&type=script&lang=js"

import "./elDialogZlcx.vue?vue&type=style&index=0&id=2ba5ef3f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__